import React from 'react'
import Box from '@material-ui/core/Box'
import SectionTitle from 'components/section-title'
import { flags, useFeatureFlags } from 'lib/feature-flags'
import UpcomingLessons from './upcoming-lessons'
import RecentLeads from './recent-leads'
import StudentsToFollowUp from './students-to-follow-up'
import useStyles from './styles'

const ManageBusiness = ({ upcomingLessons, lessonsLoading }) => {
  const classes = useStyles()
  const [isStudentInsightsEnabled] = useFeatureFlags([
    flags.FLAG_FEAT_STUDENT_INSIGHTS,
  ])

  return (
    <Box className={classes.section}>
      <SectionTitle size="large" className={classes.sectionTitle}>
        Manage your coaching business
      </SectionTitle>
      <Box className={classes.grid}>
        {isStudentInsightsEnabled ? (
          <StudentsToFollowUp className={classes.fullWidth} />
        ) : null}
        <UpcomingLessons lessons={upcomingLessons} loading={lessonsLoading} />
        <RecentLeads />
      </Box>
    </Box>
  )
}

export default ManageBusiness
